import { useQuery } from "@tanstack/react-query";
import type { FeatureFlagAuditView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

// Lazily fetched — only enabled once the row's history panel is expanded.
export function useFeatureFlagAuditQuery(id: string, enabled: boolean) {
  const query = useQuery({
    queryKey: queryKeys.admin.featureFlagAudit(id),
    queryFn: () =>
      apiJsonClient<FeatureFlagAuditView[]>(
        endpoints.admin.featureFlagAudit(id),
      ),
    enabled,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
